var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.componentKey,staticClass:"container v-content-container tooltip-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',[_c('i',{staticClass:"fa fa-fw fa-lg fa-list-alt"}),_vm._v(" External venues "),_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
            content: _vm.$label('event.create_new_venue', 'Create new venue'),
            classes: 'custom-tooltip'
          }),expression:"{\n            content: $label('event.create_new_venue', 'Create new venue'),\n            classes: 'custom-tooltip'\n          }"}],staticClass:"btn btn-v-lightgreen-white pull-right",attrs:{"to":{ name: 'NewEventVenue' }}},[_c('i',{staticClass:"fa fa-fw fa-lg fa-plus"})])],1)])]),_c('navigation-tabs'),_vm._m(0),_c('alert-box',{directives:[{name:"show",rawName:"v-show",value:(_vm.failedRequest && !_vm.loading),expression:"failedRequest && !loading"}],attrs:{"type":"warning","closeable":false,"show-icon":false}},[_vm._v(" "+_vm._s(_vm.$label( "event.event_failed_request", "Request failed while loading external venues." ))+" ")]),_c('Table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.failedRequest),expression:"!failedRequest"}],attrs:{"id":"external-venues-table","loading":_vm.loading,"columns":[
      {
        title: 'Name',
        field: 'name',
        id: function (row) { return ("venue-name-" + (row.id)); }
      },
      {
        title: 'Place',
        id: function (row) { return ("venue-place-" + (row.id)); },
        value: function (row) { return row.address ? ((row.address.post_code) + " " + (row.address.city)) : ''; }
      },
      {
        title: 'Street',
        id: function (row) { return ("venue-street-" + (row.id)); },
        value: function (row) { return (row.address ? row.address.street_name : ''); }
      }
    ],"actions":[
      {
        type: 'detail',
        onClick: function (row) {
          _vm.$router.push({
            name: 'EventVenueDetails',
            params: {
              venue_id: row.id
            }
          });
        }
      },
      {
        type: 'delete',
        id: function (row) { return ("delete-venue-button-" + (row.id)); },
        onClick: function (row) { return _vm.deleteVenue(row.id); }
      }
    ],"data":_vm.venues,"meta":_vm.metaData},on:{"fetchQuery":function (params) {
        _vm.fetchParams = params;
        _vm.getVenues({
          //
        });
      }}},[_c('div',{staticClass:"btn-group",staticStyle:{"margin-left":"5px"},attrs:{"slot":"toolbar","id":"action-dropdown"},slot:"toolbar"},[_c('button',{staticClass:"btn btn-primary dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "+_vm._s(_vm.$label("common.actions", "Actions"))+" "),_c('span',{staticClass:"caret"})]),_c('ul',{staticClass:"dropdown-menu",attrs:{"role":"menu"}},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'NewEventVenue' }}},[_c('i',{staticClass:"text-primary fa fa-fw fa-lg fa-plus"}),_vm._v(" "+_vm._s(_vm.$label("event.create_new_venue", "Create new venue")))])],1)])])]),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-8"},[_c('div',{staticClass:"col-xs-12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-8"},[_c('div',{staticClass:"col-xs-12"})])}]

export { render, staticRenderFns }